import React from 'react'
import formStyles from '../form.module.css'
import iconoBanco from '../../../assets/icono-banco.png'

const DEFAULT_ACCOUNT_PLACEHOLDER = '123 456 7890123456789 0'

const getAccountDisplay = (account) => {
  if (typeof account !== 'string') return DEFAULT_ACCOUNT_PLACEHOLDER

  const trimmedAccount = account.trim()
  return trimmedAccount || DEFAULT_ACCOUNT_PLACEHOLDER
}

export const SpeiDisplay = ({
  label = 'Cuenta CLABE de 18 dígitos',
  required = false,
  account = ''
}) => {
  const displayAccount = getAccountDisplay(account)
  const hasAccount = Boolean(account?.trim())

  return (
    <div className={formStyles.field} style={{ userSelect: 'none', cursor: 'not-allowed' }}>
      <label className={formStyles.label}>
        {label} {required && <span className={formStyles.required}>*</span>}
      </label>

      <div className={formStyles.shell}>
        <span className={formStyles.prefix}>
          <img src={iconoBanco} alt="Banco" height={17} />
        </span>

        <div
          className={formStyles.input}
          role="textbox"
          aria-readonly="true"
          style={{ color: '#9e9e9e' }}
        >
          {displayAccount}
        </div>
      </div>
    </div>
  )
}

